<template>
  <svg
    width="14"
    height="17"
    viewBox="0 0 14 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="14" height="17" fill="#E5E5E5" />
    <g clip-path="url(#clip0_16130_164040)">
      <rect x="-931" y="-84" width="1280" height="832" rx="30" fill="#F5F5F5" />
      <rect x="-818" y="-29" width="1165" height="122" fill="#F5F5F5" />
      <rect
        x="-17"
        y="-15"
        width="48"
        height="48"
        rx="8"
        fill="#F14D29"
        fill-opacity="0.15"
      />
      <path
        d="M13.3 2.83332H11.13C10.7951 1.18545 9.36257 0.002125 7.69999 0H6.29998C4.6374 0.002125 3.20487 1.18545 2.86998 2.83332H0.69999C0.313393 2.83332 0 3.15045 0 3.54164C0 3.93284 0.313393 4.25 0.69999 4.25H1.39998V13.4583C1.40231 15.4134 2.96796 16.9977 4.9 17H9.1C11.032 16.9977 12.5977 15.4134 12.6 13.4583V4.25H13.3C13.6866 4.25 14 3.93288 14 3.54168C14 3.15048 13.6866 2.83332 13.3 2.83332ZM6.30001 12.0417C6.30001 12.4329 5.98662 12.75 5.60002 12.75C5.21339 12.75 4.9 12.4329 4.9 12.0417V7.79168C4.9 7.40048 5.21339 7.08336 5.59999 7.08336C5.98658 7.08336 6.29998 7.40048 6.29998 7.79168L6.30001 12.0417ZM9.1 12.0417C9.1 12.4329 8.78661 12.75 8.40001 12.75C8.01342 12.75 7.70002 12.4329 7.70002 12.0417V7.79168C7.70002 7.40048 8.01342 7.08336 8.40001 7.08336C8.78661 7.08336 9.1 7.40048 9.1 7.79168V12.0417ZM4.31971 2.83332C4.61745 1.98495 5.41033 1.41774 6.30001 1.41664H7.70002C8.5897 1.41774 9.38259 1.98495 9.68033 2.83332H4.31971Z"
        fill="#F14D29"
      />
    </g>
    <defs>
      <clipPath id="clip0_16130_164040">
        <rect x="-931" y="-84" width="1280" height="832" rx="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
